"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BundleIcon = function (_React$Component) {
    _inherits(BundleIcon, _React$Component);

    function BundleIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BundleIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BundleIcon.__proto__ || Object.getPrototypeOf(BundleIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                "svg",
                { id: "home-auto-insurance", xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 23.999 24" },
                _react2.default.createElement(
                    "g",
                    { id: "Group_97", transform: "translate(-96.001 -912)" },
                    _react2.default.createElement(
                        "g",
                        { id: "smart-house-car" },
                        _react2.default.createElement("path", { fill: color, id: "Shape_375", d: "M110.75,922.5h-.469a3,3,0,0,0-2.911,2.272l-.509,2.039a.25.25,0,0,1-.243.189H99.643a.639.639,0,0,1-.643-.634V920.5a.5.5,0,0,0-.5-.5H96.643a.643.643,0,0,1-.6-.418.628.628,0,0,1,.189-.7l8.356-6.732a.652.652,0,0,1,.832,0l8.352,6.734a.627.627,0,0,1,.189.7.643.643,0,0,1-.6.416H111.5a.5.5,0,0,0-.5.5v1.75A.25.25,0,0,1,110.75,922.5Z", fillRule: "evenodd" }),
                        _react2.default.createElement("path", { fill: color, id: "Shape_376", d: "M118.1,928.388l1.461,1.466a1.49,1.49,0,0,1,.439,1.06V932.5a1.5,1.5,0,0,1-1.286,1.485.249.249,0,0,0-.214.247V935a1,1,0,0,1-2,0v-.75a.25.25,0,0,0-.25-.25h-6.5a.25.25,0,0,0-.25.25V935a1,1,0,0,1-2,0v-.768a.249.249,0,0,0-.214-.247A1.5,1.5,0,0,1,106,932.5v-1.586a1.49,1.49,0,0,1,.439-1.06l1.466-1.466a.25.25,0,0,0,.066-.116l.78-3.119a1.885,1.885,0,0,1,1.832-1.431h4.839a1.886,1.886,0,0,1,1.832,1.431l.78,3.119A.25.25,0,0,0,118.1,928.388Zm-2.7-1.106a.247.247,0,0,0,.24-.311l-.264-1.055a.248.248,0,0,0-.242-.19h-4.27a.248.248,0,0,0-.242.19l-.264,1.055a.249.249,0,0,0,.242.311Z", fillRule: "evenodd" })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BundleIcon, [{
        key: "render",
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return BundleIcon;
}(_react2.default.Component);

exports.default = BundleIcon;